"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.determineCursor = void 0;
var determineCursor = exports.determineCursor = function determineCursor(currentUserRole) {
  return ['Contributor', 'Admin', 'ReadOnly'].includes(currentUserRole) ? 'default' : 'pointer';
};